import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { SuccessProps } from './success.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './success.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Success component
 * @description Content for the Success stage modal of PortfoliosSettings Edit flow
 *
 * @author Oleksii Medvediev
 * @param { SuccessProps } props - SuccessProps defined in the './success.component.tsx'
 * @category Components
 */
const Success: FC<SuccessProps> = ({ onClose, portfolioMember }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal modalId={ModalIds.portfoliosSettingsEdit} title={t('modals.portfoliosSettings.edit.success.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.portfoliosSettings.edit.success.text', { portfolioMember })}
        </Typography.Text>
        <Button type={'button'} variant={'main'} size={'large'} onClick={onClose}>
          {t('modals.portfoliosSettings.edit.success.continue')}
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
